import {observer} from "mobx-react";
import * as React from "react";

import {LeadInstallmentOptions, LeadPlanType} from "shared/functions/membersApi/types/ISignupProcess";
import FormFinancial from "./FormFinancial";
import FormFinancialSteps from "./FinancialSteps";

interface ILocalState {
    selectedDepositOption: number | undefined;
    selectedInstallmentPlan: LeadInstallmentOptions | undefined;
}

interface IProps {
    store: any;
    isAmountLocked?: boolean
}

const storePropertyName = "financial";

@observer
export default class FormFinancialContainer extends React.Component<
    IProps> {

    public state: ILocalState = {
        selectedDepositOption: undefined,
        selectedInstallmentPlan: undefined
    };

    constructor (props: IProps) {
        super(props);
        const {store} = this.props;
        if(!store.formInput[storePropertyName]) {
            store.formInput[storePropertyName] = {};
        }
        store.navigationController[storePropertyName] = false;
    };

    public render() {
        const {store} = this.props;
        return (<FormFinancial
            onInstallmentSelect={this.selectInstalment}
            isInstallmentSelected={this.isInstallmentSelected}
            steps={this.getFinancialSteps()}
            store={store}/>);
    };

    private isInstallmentSelected = (val: number) => {
        return this.props.store.formInput.financial.installmentPlan === val;
    };

    private selectInstalment = (val: LeadInstallmentOptions) => {
        const {store} = this.props;
        if(!store.formInput[storePropertyName].rentAmount && !store.formInput[storePropertyName].loanAmountStep && !store.formInput[storePropertyName].amount) {
            return;
        }
        store.showResetFormButton = false;
        store.formInput[storePropertyName].installmentPlan = val;
        if(store.updateFinance && store.formInput.plans.plansValue !== LeadPlanType.Loan) {
            store.updateFinance();
        }const newState = this.state;
        newState.selectedInstallmentPlan = val;
        this.setState(newState);
    };

    private selectIsDepositPaid = (selectedVal: any) => {
        const selectedOption = selectedVal.answer;
        const {store} = this.props;
        store.formInput[storePropertyName].isDepositPaid =  selectedOption === 1;
        const newState = this.state;
        newState.selectedDepositOption = selectedOption;
        this.setState(newState);
    };

    private onFundingReasonSelected =  (selectedReason: string) => {
        const {store} = this.props;
        store.formInput.financial.fundReason = selectedReason;
        if (store.formInput.plans.plansValue === LeadPlanType.Loan && store.updateFinance) {
            store.updateFinance();
        }
    }

    private getFinancialSteps = () => {
        const {store, isAmountLocked} = this.props;
        const fundingPurpose = store.formInput.financial && store.formInput.financial.fundReason? store.formInput.financial.fundReason : "";
        const plan = store.formInput.plans.plansValue
        const res: any[] = [];
        const tempSteps =  [
            FormFinancialSteps.header,
            FormFinancialSteps.firstStep(plan, store, this.selectIsDepositPaid, this.state.selectedDepositOption, Boolean(isAmountLocked)),
            FormFinancialSteps.secondStep(plan, Boolean(isAmountLocked), this.isInstallmentSelected, this.selectInstalment),
            FormFinancialSteps.thirdStep( Boolean(isAmountLocked), plan, this.onFundingReasonSelected, fundingPurpose),
            FormFinancialSteps.forthStep(plan)
        ];

        tempSteps.forEach((step) => {
            if (step) {
                res.push(step)
            }
        });
        return res;

    };
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/SignUpForm/FormFinancial/FormFinancialContainer.tsx